import { render, staticRenderFns } from "./CarouselSlide.vue?vue&type=template&id=71496064&scoped=true"
import script from "./CarouselSlide.vue?vue&type=script&lang=js"
export * from "./CarouselSlide.vue?vue&type=script&lang=js"
import style0 from "./CarouselSlide.vue?vue&type=style&index=0&id=71496064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71496064",
  null
  
)

export default component.exports